import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "19",
  viewBox: "0 0 15 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M6.609 18.012a1 1 0 0 1-.74-.318l-5.6-6.012a1 1 0 0 1 1.376-1.446L6 13.5 13.342.247a1 1 0 0 1 1.402 1.421l-7.4 16.012a1 1 0 0 1-.735.332z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }